(
    function (skyward, $, undefined)
    {
        skyward.timePicker = skyward.timePicker || {};

        var init = function (selector)
        {
            $(selector + " .timePicker").each(function ()
            {
                var timePicker = $(this);
                var timePickerBox = timePicker.find(".timePickerBox");
                var timePickerButton = timePicker.find(".timePickerButton");

                var manageTimePickerFunction = function (timePickerFunction)
                {
                    return function ()
                    {
                        if (timePickerBox.is('[readonly]') || timePickerBox.is('[disabled]'))
                        {
                            return;
                        }

                        return timePickerFunction.apply(this, arguments);
                    }
                }

                timePickerBox.off("blur.timePicker");
                timePickerBox.off("keydown.timePicker");
                timePickerBox.on("blur.timePicker", manageTimePickerFunction(function ()
                {
                    if (!skyward.global.mobileAccess)
                    {
                        var newValue = skyward.timePicker.sanitizeInput(timePickerBox.val());
                        skyward.controls.setValue(timePickerBox, newValue);
                        timePickerBox.trigger('timepickerSet');
                    }
                }));
                timePickerBox.on("keydown.timePicker", manageTimePickerFunction(function (e)
                {
                    if (e.which == 67 || e.which == 78 || e.which == 84) // Key Codes: c = 67, n = 78, t = 84
                    {
                        if (!e.ctrlKey)
                        {
                            setCurrentTime(timePickerBox);
                            return false;
                        }                        
                    }
                }));

                timePickerButton.off("click.timePicker");
                timePickerButton.on('click.timePicker', manageTimePickerFunction(function ()
                {
                    setCurrentTime(timePickerBox);
                }));
            });
        };

        var setCurrentTime = function (timePickerBox)
        {
            var timeString;
            if (skyward.global.mobileAccess)
            {
                timeString = skyward.time.now();
            }
            else
            {
                timeString = skyward.clock.formatTime(skyward.time.now());
            }
            skyward.controls.setValue(timePickerBox, timeString);
        }

        var evaluatePossibleHours = function (possibleHours)
        {
            if (possibleHours == '')
            {
                return '00';
            }

            var hours = parseInt(possibleHours);
            return (isNaN(hours) || hours > 23 || hours < 0) ? null : (hours < 10) ? '0' + hours : hours.toString();
        };

        var evaluatePossibleMinutes = function (possibleMinutes)
        {
            if (possibleMinutes == '')
            {
                return '00';
            }

            var minutes = parseInt(possibleMinutes);
            return (isNaN(minutes) || minutes > 59 || minutes < 0) ? null : (possibleMinutes.toString().length == 2) ? possibleMinutes.toString() : (minutes <= 5 && minutes >= 0) ? minutes + '0' : null;
        };

        skyward.timePicker.sanitizeInput = function (initialTextBoxValue)
        {
            var pickerValue = initialTextBoxValue.split(' ').join(''); // Blank spaces removed
            pickerValue = pickerValue.split('.').join(':');

            if (pickerValue.length == 0 || !pickerValue)
            {
                return "";
            }

            var newValue = '';
            var hours = 0;
            var minutes = 0;
            var isMorning;
            var inferMorning = false;

            var colonIndex = pickerValue.indexOf(':');
            var hasColon = (colonIndex >= 0);

            var indexOfAM = pickerValue.toLowerCase().indexOf('a');
            var indexOfPM = pickerValue.toLowerCase().indexOf('p');

            var hasAM = (indexOfAM >= 0);
            var hasPM = (indexOfPM >= 0);

            // Check if Morning
            if (hasAM && hasPM)
            {
                isMorning = (indexOfAM < indexOfPM);
            }
            else if (!hasAM && !hasPM)
            {
                inferMorning = true;
            }
            else
            {
                isMorning = hasAM;
            }

            if (!inferMorning)
            {
                var indexToStop = isMorning ? indexOfAM : indexOfPM;
                pickerValue = pickerValue.substring(0, indexToStop).trim();
            }

            var pickerValueArray = [];

            if (hasColon)
            {
                pickerValueArray = pickerValue.split(':');

                if (pickerValueArray.length > 2)
                {
                    return '';
                }

                if (pickerValueArray[0] == '')
                {
                    pickerValueArray[0] = pickerValueArray[1];
                    pickerValueArray[1] = '00';
                }

                if (pickerValueArray.length == 1)
                {
                    pickerValueArray[1] = '00';
                }
            }
            else
            {
                if (pickerValue.length > 4)
                {
                    return '';
                }

                if ($.isNumeric(pickerValue))
                {
                    switch (pickerValue.length)
                    {
                        case 4:
                            pickerValueArray[0] = pickerValue.substring(0, 2);
                            pickerValueArray[1] = pickerValue.substring(2, 4);
                            break;
                        case 3:
                            if (pickerValue.charAt(0) == 0)
                            {
                                pickerValueArray[0] = pickerValue.substring(0, 2);
                                pickerValueArray[1] = pickerValue.substring(2, 3);
                            }
                            else
                            {
                                pickerValueArray[0] = pickerValue.substring(0, 1);
                                pickerValueArray[1] = pickerValue.substring(1, 3);
                            }
                            break;
                        default:
                            if (pickerValue > 12 && pickerValue % 10 < 6)
                            {
                                pickerValueArray[0] = Math.floor(pickerValue / 10);
                                pickerValueArray[1] = (pickerValue % 10) * 10;
                            }
                            else
                            {
                                pickerValueArray[0] = pickerValue;
                                pickerValueArray[1] = '00';
                            }
                            break;
                    }
                }
            }

            hours = evaluatePossibleHours(pickerValueArray[0]);
            minutes = evaluatePossibleMinutes(pickerValueArray[1]);

            if (isMorning && hours > 12)
            {
                hours = null;
            }

            if (hours == null || minutes == null)
            {
                return "";
            }

            if (hours == 0)
            {
                hours = 12;
                isMorning = true;
                inferMorning = false;
            }

            if (hours < 12 && pickerValueArray[0].toString().startsWith("0") && inferMorning)
            {
                isMorning = true;
                inferMorning = false;
            }

            if (inferMorning)
            {
                if (hours <= 23 && hours > 12)
                {
                    hours = hours - 12;
                    isMorning = false;
                }
                else
                {
                    isMorning = (hours >= 6 && hours < 12);
                }
            }

            // Produce Correct Format
            hours = hours.toString().length == 1 ? '0' + hours : hours;
            minutes = minutes.toString().length == 1 ? '0' + minutes : minutes;
            var amPM = isMorning ? ' AM' : ' PM';

            newValue = hours + ':' + minutes + amPM;

            return newValue;
        };

        skyward.timePicker.show = function (picker, animate)
        {
            return toggleVisibility(picker, true, animate);
        };

        skyward.timePicker.hide = function (picker, animate)
        {
            return toggleVisibility(picker, false, animate);
        };

        function toggleVisibility(picker, visibility, animate)
        {
            const outermostSelector = ".timePicker";
            let parentElem = picker.closest(outermostSelector);

            if (animate !== false)
            {
                parentElem.animateToggle(visibility);
            }
            else
            {
                parentElem.toggle(visibility);
            }

            if (visibility === true)
            {
                let timePickerButton = parentElem.find(".timePickerButton");
                timePickerButton.removeClass("hidden");
                picker.removeClass("hidden");
            }

            return parentElem;
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);